
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class UserInfoCard extends Vue {
  @Prop({ type: String, required: true }) public firstName: string;
  @Prop({ type: String, required: false, default: '-' }) public lastName: string;
  @Prop({ type: String, required: false }) public company: string;
  @Prop({ type: String, required: false }) public email: string;
}
